import {connect} from "react-redux"
import Cookies from "js-cookie"
import State from "../../ducks/state"
import {NEXT_COOKIE, NEXT_DIRECT_COOKIE} from "../../config/constants"

export const mapStateToProps = (state: State) => {
    const {isInternationalCountry, cookieDomain, privacyUrl} = state.request
    const {
        text: {cookiePolicy},
    } = state

    const cookieName = isInternationalCountry ? NEXT_DIRECT_COOKIE : NEXT_COOKIE
    const hasConsentCookie = !!Cookies.get(cookieName)

    return {
        cookieDomain,
        hasConsentCookie,
        privacyUrl,
        cookieName,
        text: cookiePolicy,
    }
}

export default connect(mapStateToProps)
